import React from 'react';

import StatusPanel from '../StatusPanel';

interface IFolderImportProps {
  visible: boolean;
  loading?: boolean;
  onClose?: () => void;
}

const FolderImport: React.FC<IFolderImportProps> = ({ visible, loading, onClose }) => {
  return <StatusPanel.LoadingPanel group="Folder: Import" loading={loading} visible={visible} onClose={onClose} />;
};

export default FolderImport;
